module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Dine interesser","modify":"endre"},"en":{"title":"Your Interests","modify":"modify"}}')
  delete Component.options._Ctor
}
